import React, { Component } from 'react';

class AdminSelectFloatingFilter extends Component {
    constructor(props) {
        super(props);
        this.state = { value: '', values: [], loading: false };
        this._mounted = false;
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        this._mounted = true;
        this.loadValues();
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    onParentModelChanged(parentModel) {
        try {
            var next = parentModel && typeof parentModel.filter !== 'undefined' && parentModel.filter !== null
                ? String(parentModel.filter)
                : '';
            if (next !== this.state.value) this.setState({ value: next });
        } catch (e) {}
    }

    getFetcher() {
        try {
            if (this.props.apiFetch) return this.props.apiFetch;
            if (this.props.context && this.props.context.componentParent && this.props.context.componentParent.apiFetch) {
                return this.props.context.componentParent.apiFetch;
            }
        } catch (e) {}
        return function(url, opts) { return fetch(url, opts); };
    }

    normalizeValues(values) {
        try {
            var seen = {};
            var out = [];
            (values || []).forEach(function(v) {
                try {
                    if (v === undefined || v === null) return;
                    var s = String(v).trim();
                    if (!s) return;
                    if (seen[s]) return;
                    seen[s] = true;
                    out.push(s);
                } catch (e) {}
            });
            if (this.props && this.props.sortValues) {
                out.sort(function(a, b) { return a.localeCompare(b); });
            }
            return out;
        } catch (e) {
            return [];
        }
    }

    parseResponse(data) {
        try {
            if (data && Array.isArray(data.values)) return data.values;
            if (data && Array.isArray(data.categories)) {
                return data.categories
                    .map(function(c) { return c && c.category ? c.category : null; })
                    .filter(function(v) { return !!v; });
            }
            if (data && Array.isArray(data.sources)) {
                return data.sources
                    .map(function(s) { return s && s.source ? s.source : null; })
                    .filter(function(v) { return !!v; });
            }
        } catch (e) {}
        return [];
    }

    loadValues() {
        var self = this;
        try {
            if (this.props.values && Array.isArray(this.props.values)) {
                this.setState({ values: this.normalizeValues(this.props.values), loading: false });
                return;
            }

            var url = this.props.valuesUrl;
            if (!url) {
                this.setState({ values: [], loading: false });
                return;
            }

            if (AdminSelectFloatingFilter._cache && AdminSelectFloatingFilter._cache[url]) {
                this.setState({ values: AdminSelectFloatingFilter._cache[url], loading: false });
                return;
            }

            this.setState({ loading: true });
            this.getFetcher()(url)
                .then(function(res) { return res.json(); })
                .then(function(data) {
                    var values = self.normalizeValues(self.parseResponse(data));
                    if (!AdminSelectFloatingFilter._cache) AdminSelectFloatingFilter._cache = {};
                    AdminSelectFloatingFilter._cache[url] = values;
                    if (self._mounted) self.setState({ values: values, loading: false });
                })
                .catch(function() { if (self._mounted) self.setState({ values: [], loading: false }); });
        } catch (e) {
            try { this.setState({ values: [], loading: false }); } catch (e2) {}
        }
    }

    onChange(e) {
        var self = this;
        try {
            var value = e && e.target ? e.target.value : '';
            this.setState({ value: value });
            var filterType = (this.props && this.props.filterType) ? this.props.filterType : 'equals';
            if (!this.props || typeof this.props.parentFilterInstance !== 'function') return;
            this.props.parentFilterInstance(function(instance) {
                try {
                    if (!instance || typeof instance.onFloatingFilterChanged !== 'function') return;
                    if (!value) instance.onFloatingFilterChanged(null, null);
                    else instance.onFloatingFilterChanged(filterType, value);
                } catch (e) {}
            });
        } catch (e) {}
        try {
            if (this.props && typeof this.props.onValueChanged === 'function') this.props.onValueChanged(self.state.value);
        } catch (e) {}
    }

    render() {
        var values = this.state.values || [];
        return React.createElement('select', {
            className: (this.props && this.props.className) ? this.props.className : 'bb-admin-floating-select',
            value: this.state.value || '',
            onChange: this.onChange
        },
        React.createElement('option', { value: '' }, (this.state.loading ? 'Loading…' : ((this.props && this.props.allLabel) ? this.props.allLabel : 'All'))),
        values.map(function(v) { return React.createElement('option', { key: v, value: v }, v); })
        );
    }
}

AdminSelectFloatingFilter._cache = {};

export default AdminSelectFloatingFilter;
